import React from 'react';
import {getLocale} from "@apps/Shared/Utils/Utils";
import { useGetConnectedProducersBlockQuery} from "@apps/Shared/GraphQL/generated";
import {
    ConnectedProducersListAppProps,
    ConnectedProducersListBlockProps
} from "@sharedComponents/ConnectedProducersList/types";
import ConnectedProducersList from "@sharedComponents/ConnectedProducersList/ConnectedProducersList";

function App(props: ConnectedProducersListAppProps): JSX.Element {
    const id = props.id;
    const locale = getLocale();

    const {data} = useGetConnectedProducersBlockQuery({
        id: id,
        locale: [locale]
    });

    if (data && data.ConnectedProducersListBlockModel?.items && data.ConnectedProducersListBlockModel?.items?.length > 0) {
        const item: any = data?.ConnectedProducersListBlockModel.items[0];
        const props: ConnectedProducersListBlockProps = {
            heading: item.Heading,
        }

        return (
            <ConnectedProducersList {...props} />
        )
    } else {
        return <></>
    }
}

export default App;